module.exports = __webpack_public_path__ + "img/homesol_2.e8b057be.png";